<div class="grid">
  <div class="col-12">
    <h1 class="capitalize my-1">{{ eventnew.title }}</h1>
  </div>
    <div class="
        col-12
        flex
        justify-content-center
        mt-5
        ">
        <img [src]="eventnew.image" alt="" style="max-width: 100%; max-height: 600px;">
    </div>
    <div class="col-12">
      <div class="flex flex-column font-bold mt-3">
        <small class="my-1">{{eventnew.createdAt | date}}</small>
        <small class="my-1" style="font-weight: 700;" *ngIf="eventnew.type === 'E'">Fecha del Evento: {{eventnew.eventDate | date}}</small>
      </div>

      <p #eventContent></p>

      <p class="my-5" *ngIf="eventnew.tags!.length > 0">
          Tags: <p-tag *ngFor="let itemTag of eventnew.tags" [style]="{margin: '1.5px',  backgroundColor: 'var(--primary-color)'}" value="{{itemTag}}" [rounded]="true"></p-tag>
      </p>
      <hr/>
    </div>
</div>
